module.exports = __webpack_public_path__ + "img/features_split.45b48b46.png";